module.exports = __webpack_public_path__ + "static/media/type-round.1183e76d.png";